import React from "react";
import { Link } from "react-router-dom";
import "./carrito.css";
import { useEffect } from "react";
import { useState } from "react";
import { Button, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import useShoppingKartStore from "../../Stores/shoppingKartStore";

function CarritoComponent({ shoppingKart }) {
  const deleteFromKart = useShoppingKartStore((state) => state.deleteFromKart);

  useEffect(() => {
    let total = 0;
    shoppingKart.forEach((el) => {
      total += el.qty * el.price;
    });
    setSubTotal(total);
  }, [shoppingKart]);

  const [subTotal, setSubTotal] = useState(0);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return (
    <div className="carritobody">
      <p>
        Tienes {shoppingKart.length}{" "}
        {shoppingKart.length > 1 ? "artículos" : "artículo"} en tu carrito
      </p>
      <div className="kart-items-container">
        {shoppingKart.map((el) => (
          <div className="kart-element-container" key={el.id}>
            <img width="100" height="100" src={el.productImg} />
            <div className="kart-text-container">
              <p>
                <b>{el.name}</b>
              </p>{" "}
              <br />
              <p>
                Cantidad: <b>{el.qty}</b>
              </p>
              <span>Precio: {formatter.format(Number(el.price))}</span>
            </div>
            <IconButton
              style={{
                position: "absolute",
                bottom: "5px",
                right: "15px",
              }}
              onClick={() => deleteFromKart(el)}
            >
              <FontAwesomeIcon
                icon={faTrash}
                style={{
                  color: "black",
                  transform: "scale(0.8)",
                }}
              />
            </IconButton>
          </div>
        ))}
      </div>
      <div className="total-container">
        <div className="total-amount-container">
          <span>Subtotal</span>
          <span className="total-container-price">
            {formatter.format(Number(subTotal))}
          </span>
        </div>
        <div className="total-amount-container">
          <span>Costo de envío</span>
          <span className="total-container-price">
            {formatter.format(Number(199))}
          </span>
        </div>
        <div className="total-amount-container total-ammount-container">
          <span>Total</span>
          <span className="total-container-price total-ammount-price">
            {formatter.format(Number(subTotal + 199))}
          </span>
        </div>
        <Link to="/resumen">
          <Button fullWidth variant="outlined">
            Ver resumen
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default CarritoComponent;
